import { logout, requestNewAccessToken } from 'app/auth/state/actions'
import { credentials } from 'middlewares/errorHandler/utils'
import { IFailedRequest } from '../errorHandler'
import { queryClient } from 'contexts/QueryClientProvider/query-client'

class TokenExpirationService {
  private static instance?: TokenExpirationService
  private runningRequest?: Promise<any>

  private containsToken(response: any) {
    return (
      'Data' in response &&
      'AuthenticationResult' in response.Data &&
      'AccessToken' in response.Data.AuthenticationResult &&
      response.Data.AuthenticationResult.AccessToken != null &&
      typeof response.Data.AuthenticationResult.AccessToken === 'string'
    )
  }

  async refreshAccessToken(failedRequest: IFailedRequest) {
    const { request, store } = failedRequest
    const { emailAddress, token } = credentials(store)

    if (this.runningRequest) {
      return this.runningRequest.then(request)
    }

    try {
      this.runningRequest = store.dispatch(requestNewAccessToken({ EmailAddress: emailAddress, RefreshToken: token }))

      const response = await this.runningRequest

      if (!this.containsToken(response)) {
        return store.dispatch(logout())
      }

      return request()
    } catch {
      store.dispatch(logout())
    } finally {
      this.runningRequest = undefined
    }
  }

  static getIntance() {
    if (!TokenExpirationService.instance) {
      TokenExpirationService.instance = new TokenExpirationService()
    }

    return TokenExpirationService.instance
  }
}

function tokenExpired(failedRequest: IFailedRequest) {
  const service = TokenExpirationService.getIntance()

  return service.refreshAccessToken(failedRequest).then(() => {
    // Because the feature flag endpoint doesn't require authentication
    // it'll still succeeded even if the token is expired.
    // This does however cause user specific flags not to be returned.
    // For that reason we're invalidating the enabled features query
    // after refreshing the access token.
    queryClient.invalidateQueries(['enabled-features'])

    const state = failedRequest.store.getState()
    const shopID = state?.auth?.currentShop
    if (shopID) {
      queryClient.invalidateQueries(['PLANNED_DURATION_SETTINGS_KEY', shopID])
    }
  })
}

export default tokenExpired
